module.exports = {"dashboard":"Tableau de bord","search":"Chercher","calendar":"Calendrier","mailbox":"Boites aux lettres","widgets":"Widgets","social":"Social","charts":"Graphiques","media":"Médias","overlays":"Superpositions","snackbar":"Snackbar","authorization":"Autorisation","login":"S'identifier","users":"Utilisateurs"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr.json
// module id = FiWC
// module chunks = 1